import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext } from "react";
import Context, { defaultLanguage } from "./Context";

var formatLanguage = function formatLanguage(language) {
  return language.replace(/-/, "");
};

function useLocalization(languages) {
  var _useContext = useContext(Context),
      language = _useContext.language;

  var contextStrings = languages[formatLanguage(language)];
  var fallbackStrings = languages[formatLanguage(defaultLanguage)];
  return {
    strings: _objectSpread(_objectSpread({}, fallbackStrings), contextStrings),
    language: language
  };
}

export default useLocalization;